export interface ScannerCallbackState {
  deviceId: string;
  previousPurchaseId?: string;
  session?: string;
  email?: string;
}

function isScannerCallbackState(v: unknown): v is ScannerCallbackState {
  return (
    typeof v === "object" &&
    v !== null &&
    "deviceId" in v &&
    (!("email" in v) || typeof (v as Record<string, unknown>).email === "string")
  );
}

export function encodeCallbackState(state: ScannerCallbackState): string {
  return btoa(JSON.stringify(state));
}

export function decodeCallbackState(encoded: string): ScannerCallbackState | null {
  try {
    const parsed: unknown = JSON.parse(atob(encoded));
    return isScannerCallbackState(parsed) ? parsed : null;
  } catch {
    return null;
  }
}
